module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('h1', {
    staticClass: "m-label"
  }, [_vm._v("先生ファイル")]), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', [_vm._v("id")]), _vm._v(" "), _c('th-c', [_vm._v("tutor_id")]), _vm._v(" "), _c('th-c', [_vm._v("user_id")]), _vm._v(" "), _c('th-c', [_vm._v("ファイル名")]), _vm._v(" "), _c('th-c', [_vm._v("作成日")])], 1), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-td"
    },
    slot: "tr-td"
  }, [_c('td-c', [_vm._v(_vm._s(_vm.tutorfile.id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.tutorfile.tutor_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.tutorfile.user_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.tutorfile.file_name))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.tutorfile.created_at))])], 1)], 1), _vm._v(" "), (_vm.tutorfile.id) ? [_c('iframe', {
    attrs: {
      "src": _vm.files + _vm.tutorfile.id + '_t.pdf',
      "frameborder": "0"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd772c7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutorfile/Tutorfile.vue
// module id = 1492
// module chunks = 0